export default "__VITE_ASSET__BSULpL4q__"